module.exports = "<div class=\"alert alert-danger\" role=\"alert\">\n  <h1 ng-bind=\"'UNAUTHORIZED' | translate\"></h1>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/errors/unauthorized/unauthorized.html
 ** module id = 354
 ** module chunks = 0
 **/